import Age from '../../../Dates/Age';

export default function TermLength(tobacco, dateOfBirth) {
    const age = dateOfBirth ? Age(dateOfBirth) : null;
    const useTobacco = tobacco === "true" ? true : false;
    if (age < 18) {
        return "";
    } else if (age > 17 && age < 66) {
        return "20";
    } else if (age > 65 && age < 71 && !useTobacco) {
        return "20";
    } else if (age > 65 && age < 71 && useTobacco) {
        return "15";
    } else if (age > 70 && age < 76 && !useTobacco) {
        return "15";
    } else if (age > 70 && age < 76 && useTobacco) {
        return "10";
    } else if (age > 75 && age < 81 && !useTobacco) {
        return "10";
    } else {
        return "";
    }
}
